import { render, staticRenderFns } from "./CreatePlantDocumentView.vue?vue&type=template&id=e8a97906&scoped=true&"
import script from "./CreatePlantDocumentView.vue?vue&type=script&lang=ts&"
export * from "./CreatePlantDocumentView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8a97906",
  null
  
)

export default component.exports